import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { I18nModule, TranslationService } from '@spartacus/core';
import { SharedModule } from "src/app/shared/shared.module";
import { CustomLandingModule } from '../../custom-landing.module';
import { CustomProductsService } from '../../custom-products/custom-products.service';
import { CustomProfileService } from 'src/app/core/services/custom-profile.service';
import { ToastrService } from 'ngx-toastr';
import { MasterData } from 'src/app/core/model/master-data.model';
import { NgSelectComponent, NgSelectModule } from '@ng-select/ng-select';
import { NgbDate, NgbDateParserFormatter, NgbDatepickerModule, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { InfiniteScrollDirective } from 'ngx-infinite-scroll';
import moment from 'moment';


@Component({
  selector: 'app-ships-rail-details',
  standalone: true,
  imports: [NgbDatepickerModule,CustomLandingModule,CommonModule ,FormsModule,NgSelectModule, RouterModule, I18nModule, SharedModule,InfiniteScrollDirective],
  templateUrl: './ships-rail-details.component.html',
  styleUrl: './ships-rail-details.component.scss'
})
export class ShipsRailDetailsComponent implements OnInit {
  @ViewChild(NgSelectComponent) ngSelectComponent: NgSelectComponent;
  readonly DELIMITER = '/';
  title: any;
  navigationData: string;
  enableLoader:boolean= true;
  railid :any;
   portData: any[] = [];
   AgentsList: any[] = [];
  StatusList: any[] = [];
    masterData: any;
    selectedPort: any;
  selectedStatus: any;
  searchValue: any = null;
  showClear: boolean = false;
  fromDetails: boolean;
  searchText= null;
  tableheaders: any[];
  railDetailsData:any [];
  scrollLeft = 0;
  currentPage = 1;
  itemsPerPage: any;
  totalItems: any;
  totalPage: any;
  hasNext: any;
  hasPrevious: any;
  sidebar: boolean;
  length: number;
  selectYear: string;
  selectMonth: string;
  nextMonth: string;
  preMonth: string;
  hoveredDate: NgbDate | null = null;
   startDate: NgbDate | null = null;
   endDate: NgbDate | null = null;
  pageSize=25;
    left = 0;
    id: any;
   passingArray: any = {};
   documents: any[] = [];
  railList: { pagination: { count: number; hasNext: boolean; hasPrevious: boolean; page: number; totalCount: number; totalPages: number; }; railDataList: ({ railNumber: string; atds: string; destination: string; totalActualQty: string; totalScheduleQty: string; railCars: string; etad: string; etds: string; status: string; statusCode: string; } | { railNumber: string; atds: string; destination: string; totalActualQty: string; totalScheduleQty: string; railCars: string; etds: string; status: string; statusCode: string; etad?: undefined; })[]; };
railData:any;
  constructor(public cd: ChangeDetectorRef,private translation: TranslationService,private customProductService: CustomProductsService,
     private customProfileService: CustomProfileService, private toastrService: ToastrService,private router: Router,
    private route: ActivatedRoute,public formatter: NgbDateParserFormatter, private http: HttpClient){

  
  }

  ngOnInit(): void {
    this.sidebar = true;
    this.id = this.route.snapshot.paramMap.get('id');
   
  const navigation = this.router.getCurrentNavigation();
  const shipmentTab=navigation?.extras?.state?.['shipmentTab']||history.state['shipmentTab'];
  const actualQtyUnit=navigation?.extras?.state?.['actualQtyUnit']||history.state['actualQtyUnit'];
  const scheduleQtyUnit=navigation?.extras?.state?.['scheduleQtyUnit']||history.state['scheduleQtyUnit'];

   this.passingArray = {
      shipmentTab: shipmentTab,
      searchText: this.id
    }
 const scheduleQtyToShow = scheduleQtyUnit?'('+scheduleQtyUnit+')':' '
 const actualQtyToShow = actualQtyUnit?'('+actualQtyUnit+')':' '

    this.railid = this.id;
      this.translation
          .translate('breadcrumb.raildetails.pageTitle')
          .subscribe(res => {
            this.title = res;
          });
           this.translation
          .translate('breadcrumb.raildetails.breadcrumb')
          .subscribe(res => {
            this.navigationData = res;
          });
      console.log('title-->',this.title,this.navigationData)
       //this.getMasterData();
       this.getFilters();
        this.getRailDetailsData();
        this.tableheaders = [
           'Rail (Shipment no)',
          'Rail Car Id',
          'Material',
          'Schedule quantity'+scheduleQtyToShow,
          'Actual quantity'+actualQtyToShow,
          'Contract ID',
          'Master Agreement No',
          'External reference no',
          'Batch ID',
          'Destination',
          'ETDS',
          'ATDS',
          'ETAD',
          'Documents',
          'Remarks',
          'Status'
        ];
 
  }

  closebar() {
    this.sidebar = true;
  }
  filtersidebar() {
    this.sidebar = false;
  }

  backToRailsList(){
    this.router.navigate(['shipment/rails'],{queryParams:{from:'details'},skipLocationChange: false })
  }
  clearFilterDataMobile(event): void {
    this.closebar();
    const checked = false;
    this.StatusList.forEach(item => (item.selected = checked));
  //this.OwnerList.forEach(item => (item.selected = checked));
   // this.shipStatusList.forEach(item=>(item.selected = checked));
   // this.selectedPort = [];
    
    this.selectedStatus = [];
    this.searchText = null;
     this.getRailDetailsData();
  }
   homeLinkClick(value): any{
    this.customProductService.getHomeLinkActive(value);
  }

  //  getMasterData(): void {
  //     this.enableLoader = true;
  //     let toastshown=false;
  //      let page='RAILCAR';
  //     this.customProfileService.getFiltersShipsDocsRails(page).subscribe((res) => {
  //       if (res) {
  //         this.enableLoader = false;
  //         this.StatusList = res.shipmentStatus;
  //       } (error) => {
  //         this.enableLoader = false;
  //         // this.toastrService.show('Something went wrong please contact support team.')
  //         this.translation.translate('shipment.erroroccuredmessage').subscribe(res=>{   
  //           if(!toastshown){
  //             this.toastrService.show(res);
  //             toastshown=true;
  //           }
  //         })
  //       }
  //     });
  //   }

  getFilters(){
    let page='RAILCAR';
     this.customProfileService.getFiltersShipsDocsRails(page).subscribe((data) => {
      console.log('filter-->',data)
      if (data) {
        this.StatusList = data.shipmentStatus;
      }(error) => {
          this.enableLoader = false;
          // this.toastrService.show('Something went wrong please contact support team.')
           this.toastrService.show(
          'Something went wrong please contact support team.'
        );
        }
     });

  }

    changeStatus() {
        console.log('selected status-->',this.selectedStatus)

      if((this.startDate==null ||this.startDate == undefined) &&
      (this.endDate==null ||this.endDate == undefined) &&
      (this.selectedStatus?.length == 0 ||this.selectedStatus?.length==undefined)){       
        this.showClear = false;
        } else {
          this.showClear = true;
        }
        this.getRailDetailsData();
      }


    // changeStatus() {
    //   if((this.selectedStatus?.length == 0 ||this.selectedStatus?.length==undefined)){        
    //       this.showClear = false;
    //       } else {
    //         this.showClear = true;
    //       }
    // }

  omitSpecialChar(event): any {
    if (this.searchValue?.length >= 2) {
      this.showClear = false;
      // this.selectedPort = null;
      // this.selectedProductType = null;
      // this.selectedProduct = null;
      // this.query = null;
      // this.currentPage = 0;
    }
    const k = event.charCode;
    if (k === 46) {
      return false;
    }
    // return this.isValidLetter(k);
  }

    filter(){
    this.route.queryParams.subscribe(params=>{
      this.fromDetails=params['from']==='details';
     })
     if(!this.fromDetails){
      this.clearAllFilter();
     }
  
 this.customProfileService.getstatus().subscribe((data)=>{
  if(data?.length){
    this.selectedStatus = data;
    this.changeStatus();
  }
})
this.customProfileService.getsearch().subscribe((data)=>{
  if(data?.length){
    this.searchText = data;
  }
})

  }

   clearAllFilter(): any {
    this.showClear = false;
    //this.selectedPort = [];
    this.selectedStatus = [];
    this.searchText = null;
     this.startDate = null;
    this.endDate = null;
    //his.screenCheck();
    //this.customProfileService.resetportFilter();
    this.customProfileService.resetsearchFilter();
    this.customProfileService.resetstatusFilter();
      this.getRailDetailsData();
    }

    getStatus() {
    if (this.selectedStatus) {
      return this.selectedStatus.toString().split(',').join(':')
    }
  }

   search() {
    this.searchText?.toLowerCase();
        if (this.searchText?.length >= 2 || this.searchText?.length === 0) {       
          this.getRailDetailsData();
        } 
  }
   
     
    getRailDetailsData(){
    this.enableLoader = true;
    let toastshown=false;
     let currPage: number;
    currPage = this.currentPage - 1;
    console.log('status-->',this.selectedStatus);
    const requestParams = {
      currentPage: currPage,
      pageSize: this.pageSize,
      searchText: this.searchText,
      status: this.selectedStatus?.length?this.selectedStatus : '',
      startDate:this.startDate ? this.startDate.year+'-'+this.startDate.month+'-'+this.startDate.day : '',
      endDate:this.endDate ?  this.endDate.year+'-'+this.endDate.month+'-'+this.endDate.day  : '',
    };
    console.log('requestParams-->',requestParams);
    
    this.customProfileService.getRailDetailsData(this.passingArray,requestParams).subscribe((data) => {
      console.log('railDetails-->',data)
      if (data) {
        this.enableLoader = false;
        this.railDetailsData = data.railCarList || [];
        
        // Process each rail car to extract documents
        this.railDetailsData.forEach((railCar: any) => {
          if (railCar.documents && Array.isArray(railCar.documents)) {
            const documentMap=new Map<string,any>()
            railCar.documents.forEach((doc: any) => {
              const documentKey = doc.documentId
              if (!documentMap.has(documentKey)) {
          documentMap.set(documentKey, doc);
              }
            });
            railCar.documents = Array.from( documentMap.values());
          }
        });
        console.log('railDetailsData-->', this.railDetailsData);
        if(this.railDetailsData.length>0){
        this.hasNext = data.pagination.hasNext;
        this.hasPrevious = data.pagination.hasPrevious;
        this.currentPage = data.pagination.page + 1;
        this.itemsPerPage = data.pagination.count;
        this.totalItems = data.pagination.totalCount;
        this.totalPage = data.pagination.totalPages;
        }
      
      }
      else {
        this.enableLoader = false;
        this.translation.translate('shipment.emptyerrormessage').subscribe(res=>{   
          if(!toastshown){
            this.toastrService.show(res);
            toastshown=true;
          }
        })
      }
    }, err => {
      this.translation.translate('shipment.erroroccuredmessage').subscribe(res=>{   
        if(!toastshown){
          this.toastrService.show(res);
          toastshown=true;
        }
      })
      this.enableLoader = false;
    })
    }

      get showingFrom(): number {
    return (this.currentPage - 1) * this.itemsPerPage + 1;
  }
  get showingTo(): number {
    const to = this.currentPage * this.itemsPerPage;
    return to > this.totalItems ? this.totalItems : to;
  }

   toggle(data: any) {
    data.toggle();
    let element3 = document.getElementsByClassName(
      'btn btn-link ngb-dp-arrow-btn'
    );
    for (let i = 0; i < element3.length; i++) {
      let value = element3[i].getAttribute('title');
      console.log(value);
      element3[i].setAttribute('title', this.setTitle(value));
    }

    let element4 = document.getElementsByTagName(
      'ngb-datepicker-navigation-select'
    )[0].children;
    for (let i = 0; i < element4.length; i++) {
      let value = element4[i].getAttribute('title');
      element4[i].setAttribute('title', this.setTitle(value));
    }
  }
   setTitle(value) {
    switch (value) {
      case 'Select year':
        return this.selectYear;
      case 'Select month':
        return this.selectMonth;
      case 'Next month':
        return this.nextMonth;
      case 'Previous month':
        return this.preMonth;
      default:
        return;
    }
  }

  onDateSelection(date: any, datePicker) {
    this.showClear = true;
    if (!this.startDate && !this.endDate) {
      this.startDate = date;
    } else if (
      this.startDate &&
      !this.endDate &&
      date &&
      date.after(this.startDate)
    ) {
      this.endDate = date;
      //this.filterData();
      this.getRailDetailsData();
      datePicker.close();

    } else {
      this.endDate = null;
      this.startDate = date;

    }
  }

   isHovered(date: NgbDate) {
      return (
        this.startDate &&
        !this.endDate &&
        this.hoveredDate &&
        date.after(this.startDate) &&
        date.before(this.hoveredDate)
      );
    }
  
    isInside(date: NgbDate) {
      return (
        this.endDate && date.after(this.startDate) && date.before(this.endDate)
      );
    }
  
    isRange(date: NgbDate) {
      return (
        date.equals(this.startDate) ||
        (this.endDate && date.equals(this.endDate)) ||
        this.isInside(date) ||
        this.isHovered(date)
      );
    }

  getShipConsignList() {
   

  }
    downloadShipmentReport(reportType) {
    let toastshown = false;
    if (reportType === 'SHIPS_AND_DOCS_RAIL_DETAIL_REPORT') {
      this.enableLoader = true;
      this.customProfileService.exportReport(reportType, null, this.id).subscribe(response => {
        if (response.status == 'success') {
          const ref = document.createElement("a");
          ref.href = `data:application/xlsx;base64,${response.code}`
          if(reportType === 'SHIPS_AND_DOCS_RAIL_DETAIL_REPORT'){
            ref.download = `ShipsAndDocsRailReport.xlsx`
          }
           ref.click();
          this.enableLoader = false;
          this.translation.translate('shipment.downloaddoc').subscribe(res=>{
            if(!toastshown){
              this.toastrService.show(res);
              toastshown=true;
            }
          })
        }
        else {
          this.enableLoader = false;
          this.toastrService.show(response.status);
        }
      }, err => {
        this.enableLoader = false;
        // this.toastrService.show('Download unsuccessful, please contact support team.');
        this.translation.translate('shipment.downloadunsuccess').subscribe(res=>{   
          if(!toastshown){
            this.toastrService.show(res);
          }
        })
      })
    }
    
  
  }
    nextPage() {
      if (this.hasNext && this.currentPage < this.totalPage) {
        this.currentPage++;
        this.getRailDetailsData();
      }
    }

    previousPage() {
      if (this.hasPrevious && this.currentPage > 1) {
        this.currentPage--;
        this.getRailDetailsData();
      }
    }

    firstPage() {
      if (this.hasPrevious && this.currentPage > 1) {
        this.currentPage = 1;
        this.getRailDetailsData();
      }
    }

    lastPage() {
      if (this.hasNext && this.currentPage < this.totalPage) {
        this.currentPage = this.totalPage;
        this.getRailDetailsData();
      }
    }
    donwloadReport(doc) {
      this.enableLoader = true;
      this.cd.detectChanges();
      this.left = window.outerWidth / 2;
      this.customProductService.getSdocsString(doc.documentId, null, doc.nominationKey, doc.nominationKeyItem).subscribe(base64 => {
        if (base64.status == 'SUCCESS') {
            if (base64.downloadableUrl!=='NOT_FOUND') {//check whether url is there
            this.http.get(base64.downloadableUrl, { responseType: 'blob' }).subscribe((blob: Blob) => {
              const url = window.URL.createObjectURL(blob);//store the actual pdf in a browsers memory
              const ref = document.createElement("a");
              ref.href = url;
              ref.download = `${doc.documentName}.pdf`
              ref.click()
              window.URL.revokeObjectURL(url);//on click revoke the url and download it to system
              this.enableLoader = false;
              this.toastrService.show('Document downloaded successfully');
            });
            } else {
            this.enableLoader = false;
            this.toastrService.show('Document not available');
            }
        }
        else {
          this.enableLoader = false;
          this.toastrService.show('Download unsuccessful, please contact support team.');
        }
      })

  }

}
